module.exports = __webpack_public_path__ + "main/images/learnmore/save-to-pocket.d7575601bd06e915c21afdfe72393193.svg";